'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ChangeCategoryService = function ChangeCategoryService($http) {

    var changeCategoryArray = [];

    /**
     * Get the list of care types
     */

    var data = function data() {
        if (changeCategoryArray.length === 0) {
            changeCategoryArray = $http.get(WEBSERVICEURL + '/dataagility/api/service.changecategory/').then(function (response) {
                return response.data;
            });
        }

        return changeCategoryArray;
    };

    return { data: data };
};

exports.default = ChangeCategoryService;


// WEBPACK FOOTER //
// ./client/app/common/services/changeCategory.service.js